<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <gstar-countries-combobox
    [value]="countryValue"
    [disabled]="isEdit"
    (clearCountry)="countryClear()"
    (selectCountry)="countrySelect($event)"
    [title]="'investmentJurisdiction.country' | translate" />
  @if (countryField.errors?.['required']) {
    <div class="ap-field-validation-error">
      {{ 'formValidations.required' | translate }}
    </div>
  }
  <ap-field
    [title]="'investmentJurisdiction.region' | translate"
    [disabled]="true">
    <input appkit-field formControlName="region" />
  </ap-field>

  <ap-checkbox formControlName="isActive" class="mt-2">
    {{ 'investmentJurisdiction.isActive' | translate }}
  </ap-checkbox>
  <ap-checkbox formControlName="isDisplay" class="mt-2">
    {{ 'investmentJurisdiction.isDisplay' | translate | slice: 0 : 14 }}
  </ap-checkbox>
</form>
